import styled, { css } from "styled-components";
import Button from "../../components/button";

export const Container = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	flex-direction: column;
`

export const SectionContainer = styled.section`
	position: relative;
	width: 100%;
`

export const SectionHeader = styled.div`
	background: #eee;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 7px;
	padding: 10px 0;
	position: sticky;
	top: -17px;
	width: 100%;
	height: 40px;

	h3 {
		color: rgba(0,0,0,.5);
		display: inline;
	}

	span {
		color: rgba(0,0,0,.4)
	}



`

export const EntryItem = styled.li`
	display: grid;
	grid-template-columns: 1fr 4fr repeat(4, 1fr);
	padding: 10px 0;
	justify-items: start;
`


interface ICellProps {
	color?: string
	alignRight?: boolean
}

export const EntryCell = styled.div<ICellProps>`

	display: flex;
	flex-direction: column;
	gap: 10px;
	${props => props.alignRight &&
		`
		justify-self: end;
		align-items: flex-end;
	`
	}

	span {
		color: rgba(0,0,0,.4);
    font-size: 16px;
	}
	
	h3 {
		color: ${props => props.color || 'rgba(0,0,0,.5)'};
	}
	
`



export const SettingsContainer = styled.div`
	display: flex;
	width: 100%;
	margin: 20px 0;
	gap: 50px;

	@media (max-width: 1280px) {
		flex-direction: column;
		gap: 25px;
	}

	> div {
		display: flex;
		align-items: center;
		gap: 10px;

	}

	label {
		color: rgba(0,0,0,.5);
		font-weight: bold;
	}
`


const inputStyle = css`
-webkit-appearance: none;
	appearance: none;
	border: none;
	border-radius: 8px;
	background: #fff !important;
	padding: 7px 15px;
	width: 200px;
	height: 32.800px;
	display: flex;
	justify-content: space-between;
	box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
	outline: none;
	color: rgba(0,0,0,.5);
`


export const Dropdown = styled.button`
	${inputStyle}
	align-items: center;
	@media (max-width:580px) {
		width: 100%;
		max-width: 180px;
		display: flex;
	}

	@media (max-width:475px) {
		max-width: 180px;
		padding-right: 5px;
	}

	:hover{
		cursor: pointer;
	}

	span{
		color: rgba(0,0,0,.5);
    text-overflow: ellipsis;
    overflow: hidden; 
    white-space: nowrap;
	}
`


interface IInputProps {
	width?: number
}

export const DateInput = styled.input<IInputProps>`
	${inputStyle}
	width: ${props => props.width ? props.width : 200}px;
	
	&::-webkit-date-and-time-value {
		text-align: left;
	}

		@media (max-width:580px) {
		width: 100%;
		display: flex;
	}

	@media (max-width:475px) {
		max-width: 600px;
	}
`

export const SearchContainer = styled.div`
	position: relative;
	margin-left: auto;
`


export const FetchButton = styled(Button)`
	padding: 7px 15px;
	box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;

`


export const EmptyListMessage = styled.span`
	color: rgba(0,0,0,.5);
	letter-spacing: 1px;
`